import { render, staticRenderFns } from "./ProductsCardDelivery.vue?vue&type=template&id=5ec597ea&scoped=true&"
import script from "./ProductsCardDelivery.vue?vue&type=script&lang=js&"
export * from "./ProductsCardDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCardDelivery.vue?vue&type=style&index=0&id=5ec597ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec597ea",
  null
  
)

export default component.exports